// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"67fea71e43903721fb7b","131":"ea8bb44b2de8965f56ac","132":"1c6c8d44ee2720a99c02","170":"329546207598fdfbc936"}[chunkId] + ".chunk.js";
};